<template>
  <b-row>
    <b-col cols="12">
      <b-card :title="$t('Expirations report filters') ">
        <div class="m-2">

          <b-row>

            <b-col
              cols="12"
              md="3"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >

              <b-form-group
                :label="$t('Expiration till')"
                label-for="end"
              >
                <flat-pickr
                  id="end"
                  v-model="end"
                  class="form-control"
                  variant="outline-secondary"

                  :config="flatPickrConfig"
                />
              </b-form-group>

            </b-col>

            <b-col
              cols="12"
              md="3"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-form-group
                :label="$t('Filter by days to the expiration')"
                label-for="end"
              >
                <b-dropdown
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :text="filters[0].description"
                  variant="outline-secondary"
                  block
                >
                  <b-dropdown-item
                    v-for="filter in filters"
                    :key="filter.id"
                    @click="setFilter(filter.id)"
                  >
                    <span class="ml-50">{{ filter.description }}</span>
                  </b-dropdown-item>

                </b-dropdown>
              </b-form-group>

            </b-col>
            <b-col
              cols="12"
              md="4"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            />
            <b-col
              cols="12"
              md="2"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >

              <b-button
                variant="primary"
                class="button-inline-spacing-2"
                style="min-width: 135px"
                @click="default_filter()"
              >
                <span class="text-nowrap">{{ $t("Remove filter") }}</span>
              </b-button>

            </b-col>
          </b-row>

          <b-row>

            <b-col
              cols="12"
              md="10"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >

              <b-form-group
                :label="$t('Filter by company')"
                label-for="company"
              >
                <v-select
                  v-model="selectedCompany"
                  :options="companies"
                  :get-option-label="option => option.name"
                  label="Search for a company"
                  @input="setCompany(selectedCompany)"
                />
              </b-form-group>

            </b-col>

            <b-col
              cols="12"
              md="2"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="button-inline-spacing-2"
                style="min-width: 135px"
                @click="download_report()"
              >
                <feather-icon
                  icon="PrinterIcon"
                  class="mr-50"
                />
                <span class="align-middle">{{ $t("Export") }}</span>
              </b-button>

            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-card-actions
        ref="other_expirations_list"
        :title="$t('Other expirations')"
        action-collapse
      >
        <!-- table -->
        <vue-good-table
          :columns="other_columns"
          :rows="filteredOtherExpirations"
          :rtl="direction"

          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"

          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'company', type: 'asc'}

          }"
        >

          <!-- Slot: Table Column -->
          <template
            slot="table-column"
            slot-scope="props"
          >

            <span>
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template
            slot="table-row"
            slot-scope="props"
          >

            <!-- Column: Company -->
            <span
              v-if="props.column.field === 'company'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.company }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'name'"
              class="text-nowrap v-align-middle"
            >
              <span>   {{ $t(props.row.name) }}</span>

            </span>

            <!-- Column: title -->
            <span
              v-if="props.column.field === 'title'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.title }}</span>
            </span>

            <!-- Column: date_event -->
            <span
              v-if="props.column.field === 'date_event'"
              class="text-nowrap v-align-middle date"
            >
              <span>{{ props.row.date_event }}</span>
            </span>

            <!-- Column: expiration -->
            <span
              v-if="props.column.field === 'expiration'"
              class="text-nowrap v-align-middle date"
            >
              <b-badge
                pill
                :variant="getExpirationVariant(props.row)"
                class="text-capitalize"
              >
                {{ props.row.expiration }}
              </b-badge>

            </span>

            <!-- Column: Action -->
            <span
              v-else-if="props.column.field === 'action'"
              class="button-inline-spacing"
            >

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="edit(props.row)"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="deleteDepartment(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </span>

            <span
              v-else
              class="text-nowrap align-middle"
            />
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >

            <div class="d-flex justify-content-between flex-wrap">

              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t('message.pagelength') }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['25','50','100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{
                  $t('message.pageText2')
                }} </span>
              </div>
              <div>

                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>

                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </b-card-actions>
      <b-card-actions
        ref="courses_list"
        :title="$t('Expiring courses reports')"
        action-collapse
      >
        <!-- table -->
        <vue-good-table
          :columns="courses_columns"
          :rows="filteredCourses"
          :rtl="direction"
          :selected-rows="courses"

          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"

          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'company', type: 'asc'}

          }"
        >

          <!-- Slot: Table Column -->
          <template
            slot="table-column"
            slot-scope="props"
          >

            <span>
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template
            slot="table-row"
            slot-scope="props"
          >

            <!-- Column: Company -->
            <span
              v-if="props.column.field === 'company'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.company }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'name'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.name }}</span>
            </span>

            <!-- Column: title -->
            <span
              v-if="props.column.field === 'title'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.title }}</span>
            </span>

            <!-- Column: date_event -->
            <span
              v-if="props.column.field === 'date_event'"
              class="text-nowrap v-align-middle date"
            >
              <span>{{ props.row.date_event }}</span>
            </span>

            <!-- Column: expiration -->
            <span
              v-if="props.column.field === 'expiration'"
              class="text-nowrap v-align-middle date"
            >
              <b-badge
                pill
                :variant="getExpirationVariant(props.row)"
                class="text-capitalize"
              >
                {{ props.row.expiration }}
              </b-badge>

            </span>

            <!-- Column: Action -->
            <span
              v-else-if="props.column.field === 'action'"
              class="button-inline-spacing"
            >

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="edit(props.row)"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="deleteDepartment(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </span>

            <span
              v-else
              class="text-nowrap align-middle"
            />
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >

            <div class="d-flex justify-content-between flex-wrap">

              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t('message.pagelength') }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['25','50','100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{
                  $t('message.pageText2')
                }} </span>
              </div>
              <div>

                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>

                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </b-card-actions>
      <b-card-actions
        ref="medical_list"
        :title="$t('Expiring visits reports')"
        action-collapse
      >

        <!-- table -->
        <vue-good-table
          :columns="medical_columns"
          :rows="filteredMedical"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm }"
          :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }"
          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"
        >

          <!-- Slot: Table Column -->
          <template
            slot="table-column"
            slot-scope="props"
          >

            <span>
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- Column: Company -->
            <span
              v-if="props.column.field === 'company'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.company }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'name'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.name }}</span>
            </span>

            <!-- Column: title -->
            <span
              v-if="props.column.field === 'title'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.title }}</span>
            </span>

            <!-- Column: date_event -->
            <span
              v-if="props.column.field === 'date_event'"
              class="text-nowrap v-align-middle date"
            >
              <span>{{ props.row.date_event }}</span>
            </span>

            <!-- Column: expiration -->
            <span
              v-if="props.column.field === 'expiration'"
              class="text-nowrap v-align-middle date"
            >
              <b-badge
                pill
                :variant="getExpirationVariant(props.row)"
                class="text-capitalize"
              >
                {{ props.row.expiration }}
              </b-badge>

            </span>

            <!-- Column: Action -->
            <span
              v-else-if="props.column.field === 'action'"
              class="button-inline-spacing"
            >

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="edit(props.row)"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="deleteDepartment(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </span>

            <span
              v-else
              class="text-nowrap align-middle"
            />
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >

            <div class="d-flex justify-content-between flex-wrap">

              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t('message.pagelength') }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['25','50','100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{
                  $t('message.pageText2')
                }} </span>
              </div>
              <div>

                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>

                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </b-card-actions>
      <b-card-actions
        ref="documents_list"
        :title="$t('Expiring documents reports')"
        action-collapse
      >
        <!-- table -->
        <vue-good-table
          :columns="employees_document_columns"
          :rows="filteredEmployeeDocuments"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm }"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'company', type: 'asc'}

          }"

          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"
        >

          <!-- Slot: Table Column -->
          <template
            slot="table-column"
            slot-scope="props"
          >

            <span>
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- Column: Company -->
            <span
              v-if="props.column.field === 'company'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.company }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'name'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.name }}</span>
            </span>

            <!-- Column: title -->
            <span
              v-if="props.column.field === 'title'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.title }}</span>
            </span>

            <!-- Column: date_event -->
            <span
              v-if="props.column.field === 'date_event'"
              class="text-nowrap v-align-middle date"
            >
              <span>{{ props.row.date_event }}</span>
            </span>

            <!-- Column: expiration -->
            <span
              v-if="props.column.field === 'expiration'"
              class="text-nowrap v-align-middle date"
            >
              <b-badge
                pill
                :variant="getExpirationVariant(props.row)"
                class="text-capitalize"
              >
                {{ props.row.expiration }}
              </b-badge>

            </span>

            <!-- Column: Action -->
            <span
              v-else-if="props.column.field === 'action'"
              class="button-inline-spacing"
            >

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="edit(props.row)"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="deleteDepartment(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </span>

            <span
              v-else
              class="text-nowrap align-middle"
            />
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >

            <div class="d-flex justify-content-between flex-wrap">

              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t('message.pagelength') }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['25','50','100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{
                  $t('message.pageText2')
                }} </span>
              </div>
              <div>

                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>

                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </b-card-actions>
      <b-card-actions
        ref="vehicles_list"
        :title="$t('Expiring vehicles reports')"
        action-collapse
      >

        <!-- table -->
        <vue-good-table
          :columns="vehicles_columns"
          :rows="filteredVehicles"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm }"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'company', type: 'asc'}

          }"

          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"
        >

          <!-- Slot: Table Column -->
          <template
            slot="table-column"
            slot-scope="props"
          >

            <span>
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- Column: Company -->
            <span
              v-if="props.column.field === 'company'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.company }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'name'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.name }}</span>
            </span>

            <!-- Column: title -->
            <span
              v-if="props.column.field === 'title'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.title }}</span>
            </span>

            <!-- Column: date_event -->
            <span
              v-if="props.column.field === 'date_event'"
              class="text-nowrap v-align-middle date"
            >
              <span>{{ props.row.date_event }}</span>
            </span>

            <!-- Column: expiration -->
            <span
              v-if="props.column.field === 'expiration'"
              class="text-nowrap v-align-middle date"
            >
              <b-badge
                pill
                :variant="getExpirationVariant(props.row)"
                class="text-capitalize"
              >
                {{ props.row.expiration }}
              </b-badge>

            </span>

            <!-- Column: Action -->
            <span
              v-else-if="props.column.field === 'action'"
              class="button-inline-spacing"
            >

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="edit(props.row)"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="deleteDepartment(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </span>

            <span
              v-else
              class="text-nowrap align-middle"
            />
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >

            <div class="d-flex justify-content-between flex-wrap">

              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t('message.pagelength') }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['25','50','100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{
                  $t('message.pageText2')
                }} </span>
              </div>
              <div>

                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>

                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </b-card-actions>
      <b-card-actions
        ref="equipments_list"
        :title="$t('Expiring equipments reports')"
        action-collapse
      >

        <!-- table -->
        <vue-good-table
          :columns="equipments_columns"
          :rows="filteredEquipments"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm }"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'company', type: 'asc'}

          }"

          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"
        >

          <!-- Slot: Table Column -->
          <template
            slot="table-column"
            slot-scope="props"
          >

            <span>
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- Column: Company -->
            <span
              v-if="props.column.field === 'company'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.company }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'name'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.name }}</span>
            </span>

            <!-- Column: title -->
            <span
              v-if="props.column.field === 'title'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.title }}</span>
            </span>

            <!-- Column: date_event -->
            <span
              v-if="props.column.field === 'date_event'"
              class="text-nowrap v-align-middle date"
            >
              <span>{{ props.row.date_event }}</span>
            </span>

            <!-- Column: expiration -->
            <span
              v-if="props.column.field === 'expiration'"
              class="text-nowrap v-align-middle date"
            >
              <b-badge
                pill
                :variant="getExpirationVariant(props.row)"
                class="text-capitalize"
              >
                {{ props.row.expiration }}
              </b-badge>

            </span>

            <!-- Column: Action -->
            <span
              v-else-if="props.column.field === 'action'"
              class="button-inline-spacing"
            >

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="edit(props.row)"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="deleteDepartment(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </span>

            <span
              v-else
              class="text-nowrap align-middle"
            />
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >

            <div class="d-flex justify-content-between flex-wrap">

              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t('message.pagelength') }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['25','50','100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{
                  $t('message.pageText2')
                }} </span>
              </div>
              <div>

                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>

                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </b-card-actions>
      <b-card-actions
        ref="plants_list"
        :title="$t('Expiring plants reports')"
        action-collapse
      >

        <!-- table -->
        <vue-good-table
          :columns="plants_columns"
          :rows="filteredPlants"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm }"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'company', type: 'asc'}

          }"

          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"
        >

          <!-- Slot: Table Column -->
          <template
            slot="table-column"
            slot-scope="props"
          >

            <span>
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template
            slot="table-row"
            slot-scope="props"
          >

            <!-- Column: Company -->
            <span
              v-if="props.column.field === 'company'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.company }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'name'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.name }}</span>
            </span>

            <!-- Column: title -->
            <span
              v-if="props.column.field === 'title'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.title }}</span>
            </span>

            <!-- Column: date_event -->
            <span
              v-if="props.column.field === 'date_event'"
              class="text-nowrap v-align-middle date"
            >
              <span>{{ props.row.date_event }}</span>
            </span>

            <!-- Column: expiration -->
            <span
              v-if="props.column.field === 'expiration'"
              class="text-nowrap v-align-middle date"
            >
              <b-badge
                pill
                :variant="getExpirationVariant(props.row)"
                class="text-capitalize"
              >
                {{ props.row.expiration }}
              </b-badge>

            </span>

            <!-- Column: Action -->
            <span
              v-else-if="props.column.field === 'action'"
              class="button-inline-spacing"
            >

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="edit(props.row)"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="deleteDepartment(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </span>

            <span
              v-else
              class="text-nowrap align-middle"
            />
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >

            <div class="d-flex justify-content-between flex-wrap">

              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t('message.pagelength') }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['25','50','100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{
                  $t('message.pageText2')
                }} </span>
              </div>
              <div>

                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>

                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </b-card-actions>
      <b-card-actions
        ref="fulfillments_list"
        :title="$t('Expiring fulfillments reports')"
        action-collapse
      >

        <!-- table -->
        <vue-good-table
          :columns="fulfillments_columns"
          :rows="filteredFulfillments"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm }"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'company', type: 'asc'}

          }"

          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"
        >

          <!-- Slot: Table Column -->
          <template
            slot="table-column"
            slot-scope="props"
          >

            <span>
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template
            slot="table-row"
            slot-scope="props"
          >

            <!-- Column: Company -->
            <span
              v-if="props.column.field === 'company'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.company }}</span>
            </span>

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'name'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.name }}</span>
            </span>

            <!-- Column: title -->
            <span
              v-if="props.column.field === 'title'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.title }}</span>
            </span>

            <!-- Column: date_event -->
            <span
              v-if="props.column.field === 'date_event'"
              class="text-nowrap v-align-middle date"
            >
              <span>{{ props.row.date_event }}</span>
            </span>

            <!-- Column: expiration -->
            <span
              v-if="props.column.field === 'expiration'"
              class="text-nowrap v-align-middle date"
            >
              <b-badge
                pill
                :variant="getExpirationVariant(props.row)"
                class="text-capitalize"
              >
                {{ props.row.expiration }}
              </b-badge>

            </span>

            <!-- Column: Action -->
            <span
              v-else-if="props.column.field === 'action'"
              class="button-inline-spacing"
            >

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="edit(props.row)"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="deleteDepartment(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </span>

            <span
              v-else
              class="text-nowrap align-middle"
            />
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >

            <div class="d-flex justify-content-between flex-wrap">

              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t('message.pagelength') }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['25','50','100']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{
                  $t('message.pageText2')
                }} </span>
              </div>
              <div>

                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>

                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </b-card-actions>

    </b-col>
  </b-row>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BCardActions } from '@core/components/b-card-actions'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'

import {
  BAlert,
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BPagination,
  BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import Ripple from 'vue-ripple-directive'
import ExportExcel from '@/views/components/excel-export/ExportExcel'

import Vue from 'vue'
import i18n from '@/libs/i18n'
import DashboardService from '@/basic/dashboardService'
import { environment } from '@/auth/environment'
import { withAuthToken } from '@/auth/utils'
import vSelect from 'vue-select'
import { codeI18n } from './code'

Vue.use(ExportExcel)

export default {
  components: {
    BCardCode,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BButton,
    BRow,
    BCol,
    BFormCheckbox,
    BForm,
    BCard,
    flatPickr,
    vSelect,

  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pageLength: 25,
      codeI18n,

      other_columns: [
        {
          label: 'Company',
          field: 'company',
          sortable: true,
        },
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Next expiration',
          field: 'expiration',
        },

      ],
      courses_columns: [
        {
          label: 'Company',
          field: 'company',
          sortable: true,
        },
        {
          label: 'Employee',
          field: 'name',
        },
        {
          label: 'Type of course',
          field: 'title',
        },
        {
          label: 'Course date',
          field: 'date_event',
        },
        {
          label: 'Next expiration',
          field: 'expiration',
        },

      ],
      medical_columns: [
        {
          label: 'Company',
          field: 'company',
        },
        {
          label: 'Employee',
          field: 'name',
        },
        {
          label: 'Type of visit',
          field: 'title',
        },
        {
          label: 'Visit date',
          field: 'date_event',
        },
        {
          label: 'Next expiration',
          field: 'expiration',
        },

      ],
      employees_document_columns: [
        {
          label: 'Company',
          field: 'company',
        },
        {
          label: 'Employee',
          field: 'name',
        },
        {
          label: 'Type of document',
          field: 'title',
        },
        {
          label: 'Document date',
          field: 'date_event',
        },
        {
          label: 'Next expiration',
          field: 'expiration',
        },

      ],

      vehicles_columns: [
        {
          label: 'Company',
          field: 'company',
        },
        {
          label: 'Vehicle',
          field: 'name',
        },
        {
          label: 'Type of document',
          field: 'title',
        },
        {
          label: 'Document date',
          field: 'date_event',
        },
        {
          label: 'Next expiration',
          field: 'expiration',
        },

      ],

      equipments_columns: [
        {
          label: 'Company',
          field: 'company',
        },
        {
          label: 'Equipment',
          field: 'name',
        },
        {
          label: 'Type of document',
          field: 'title',
        },
        {
          label: 'Document date',
          field: 'date_event',
        },
        {
          label: 'Next expiration',
          field: 'expiration',
        },

      ],

      plants_columns: [
        {
          label: 'Company',
          field: 'company',
        },
        {
          label: 'Plant',
          field: 'name',
        },
        {
          label: 'Type of document',
          field: 'title',
        },
        {
          label: 'Document date',
          field: 'date_event',
        },
        {
          label: 'Next expiration',
          field: 'expiration',
        },

      ],

      fulfillments_columns: [
        {
          label: 'Company',
          field: 'company',
        },
        {
          label: 'Fulfillment',
          field: 'title',
        },
        {
          label: 'Document date',
          field: 'date_event',
        },
        {
          label: 'Next expiration',
          field: 'expiration',
        },

      ],

      filters: [{ description: i18n.t('Next 30 days'), id: '30days' }, {
        description: i18n.t('Next three months'),
        id: '3months',
      }, { description: i18n.t('This year'), id: 'this_year' }],

      courses: [],
      medical: [],
      other_expirations: [],
      employee_documents: [],
      vehicles: [],
      equipments: [],
      plants: [],
      fulfillments: [],
      company: null,
      companies: [],
      selectedCompany: null, // Initially, no company is selected
      searchTerm: '',
      end: moment().add(30, 'days').format('DD/MM/YYYY'),
      edit_department_id: 0,
      flatPickrConfig: {
        dateFormat: 'd/m/Y',
        allowInput: true,
      },
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },

    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    filteredOtherExpirations() {
      if (!this.selectedCompany) {
        return this.other_expirations
      }
      return this.other_expirations.filter(
        row => row.company === this.selectedCompany.name,
      )
    },
    filteredCourses() {
      if (!this.selectedCompany) {
        return this.courses
      }
      return this.courses.filter(
        row => row.company === this.selectedCompany.name,
      )
    },
    /* courses: [],
      medical: [],
      other_expirations: [],
      employee_documents: [],
      vehicles: [],
      equipments: [],
      plants: [],
      fulfillments: [], */
    filteredMedical() {
      if (!this.selectedCompany) {
        return this.medical
      }
      return this.medical.filter(
        row => row.company === this.selectedCompany.name,
      )
    },
    filteredEmployeeDocuments() {
      if (!this.selectedCompany) {
        return this.employee_documents
      }
      return this.employee_documents.filter(
        row => row.company === this.selectedCompany.name,
      )
    },
    filteredVehicles() {
      if (!this.selectedCompany) {
        return this.vehicles
      }
      return this.vehicles.filter(
        row => row.company === this.selectedCompany.name,
      )
    },
    filteredEquipments() {
      if (!this.selectedCompany) {
        return this.equipments
      }
      return this.equipments.filter(
        row => row.company === this.selectedCompany.name,
      )
    },
    filteredPlants() {
      if (!this.selectedCompany) {
        return this.plants
      }
      return this.plants.filter(
        row => row.company === this.selectedCompany.name,
      )
    },
    filteredFulfillments() {
      if (!this.selectedCompany) {
        return this.fulfillments
      }
      return this.fulfillments.filter(
        row => row.company === this.selectedCompany.name,
      )
    },

  },

  watch: {
    end: {
      handler(newValue) {
        console.log(`watch end:${newValue}`)
        if (newValue) this.refresh()
      },
      immediate: true,
    },
  },
  mounted() {
    console.log('mounted')

    // Load companies safely from localStorage
    const { safeLocalStorageGetItem } = require('@/utils/storageUtils')
    const storedCompanies = safeLocalStorageGetItem('companies', [])

    if (storedCompanies && storedCompanies.length > 0) {
      this.companies = [...storedCompanies]
    }

    this.companies.unshift({ id: null, name: i18n.t('All') })
    this.refresh()

    this.unsubscribe = store.subscribe((mutation, state) => {
      if (mutation.type === 'selected_company') {
        console.log(`Updating selected_company to ${state.userCompany.id}`)
        this.refresh()
      }
    })

    // this.$http.get('/good-table/basic')
    // .then(res => { this.rows = res.data })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    getCompanyName(rowObj) {
      console.log('getCompanyName', rowObj.company)
      return rowObj.company.name
    },
    setCompany(company) {
      console.log('setCompany', company)
      if (company.id) this.selectedCompany = company
      else { this.selectedCompany = null }
      // Handle filtering logic here based on the selected company
      // For example, trigger a filter function or update a filter property
    },
    download_report() {
      const link = document.createElement('a')
      let end = this.end.replaceAll('/', '-')
      if (end === '') end = 'all'
      console.log('before building the download url ', this.selectedCompany)
      if (!this.selectedCompany) {
        link.href = withAuthToken(`${environment.baseURL}/dashboard/downloadEventsInPeriodAdmin/${end}`)
      } else {
        link.href = withAuthToken(`${environment.baseURL}/dashboard/downloadEventsInPeriodAdminSingleCompany/${end}/${this.selectedCompany.id}`)
      }
      console.log('after building the download url ', link.href)

      link.download = 'report_scadenze.pdf'
      link.click()
      URL.revokeObjectURL(link.href)
    },

    default_filter() {
      this.end = ''
      this.refresh()
    },
    setFilter(filter) {
      if (filter === '30days') {
        this.end = moment().add(30, 'days').format('DD/MM/YYYY')
      } else if (filter === '3months') {
        this.end = moment().add(3, 'months').format('DD/MM/YYYY')
      } else if (filter === 'this_year') {
        this.end = moment().endOf('year').format('DD/MM/YYYY')
      }
    },
    getExpirationVariant(row) {
      /// / console.log('getExpirationVariant row', row)

      if (row.color === 'red') return 'light-danger'
      if (row.color === 'orange') return 'light-warning'
      return 'light-success'
    },

    refresh() {
      console.log('refresh')
      this.$refs.other_expirations_list.showLoading = true
      this.$refs.courses_list.showLoading = true
      this.$refs.medical_list.showLoading = true
      this.$refs.documents_list.showLoading = true
      this.$refs.vehicles_list.showLoading = true
      this.$refs.plants_list.showLoading = true
      this.$refs.equipments_list.showLoading = true
      this.$refs.fulfillments_list.showLoading = true

      const dashboardService = new DashboardService(useJwt)
      const data = {
        start: this.start,
        end: this.end,
      }
      dashboardService.get_events_in_period_admin(data).then(response => {
        console.log('data', response.data.events)

        this.other_expirations = response.data.events.other_expirations
        this.courses = response.data.events.courses
        this.medical = response.data.events.medical
        this.employee_documents = response.data.events.employee_documents
        this.vehicles = response.data.events.vehicles
        this.equipments = response.data.events.equipments
        this.plants = response.data.events.plants
        this.fulfillments = response.data.events.fulfillments
        this.$refs.other_expirations_list.showLoading = false
        this.$refs.courses_list.showLoading = false
        this.$refs.medical_list.showLoading = false
        this.$refs.documents_list.showLoading = false
        this.$refs.vehicles_list.showLoading = false
        this.$refs.plants_list.showLoading = false
        this.$refs.equipments_list.showLoading = false
        this.$refs.fulfillments_list.showLoading = false
      })
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
